module.exports = __webpack_public_path__ + "img/3.d4a3c5be.png";